//  Name: title-bar
export default {
  props: []
}



// WEBPACK FOOTER //
// ./src/components/title-bar/script.js